import DashBoardPage from './DashboardPage';
export { DashBoardPage };
export default DashBoardPage;
